import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({ panelcontainer: { padding: theme.spacing(1), paddingTop: theme.spacing(1.5) }, }));
